export default {
  colors: {
    fuscia: {
      background: "#E31C79",
      darkerPrimary: "#8D0053",
      primaryText: "#000000",
      statusBarText: "light-content",
      white: "#ffffff",
      buttonText: "#ffffff",
      inActiveLabelColor: "#8e8e8f",
      ayobaThemeBackground: "#ffffff",
      ayobaButtonBackground: "#E31C79",
      ayobaButtonColor: "white",
      black: "#000000",
      accentBackground: "#ffffff",
      mashupBackground: "#FFFFFF",
    },
    amber: {
      background: "#333333",
      darkerPrimary: "#E26C05",
      primaryText: "#000000",
      statusBarText: "light-content",
      white: "#ffffff",
      buttonText: "#ffffff",
      inActiveLabelColor: "#8e8e8f",
      ayobaThemeBackground: "#ffffff",
      ayobaButtonBackground: "#F5821E",
      ayobaButtonColor: "white",
      black: "#000000",
      accentBackground: "#ffffff",
      mashupBackground: "#FFFFFF",
    },
    jasmine: {
      background: "#FFCD00",
      darkerPrimary: "#D7B118",
      primaryText: "#000000",
      statusBarText: "dark-content",
      white: "#ffffff",
      inActiveLabelColor: "#8e8e8f",
      ayobaThemeBackground: "#ffffff",
      ayobaButtonBackground: "#FFCD00",
      ayobaButtonColor: "white",
      black: "#000000",
      accentBackground: "#ffffff",
      mashupBackground: "#FFFFFF",
    },
    turquoise: {
      background: "#4EC3E0",
      darkerPrimary: "#1AAFD3",
      primaryText: "#000000",
      statusBarText: "light-content",
      white: "#ffffff",
      inActiveLabelColor: "#8e8e8f",
      buttonText: "#ffffff",
      ayobaThemeBackground: "#ffffff",
      ayobaButtonBackground: "#4EC3E0",
      ayobaButtonColor: "white",
      black: "#000000",
      accentBackground: "#ffffff",
      mashupBackground: "#FFFFFF",
    },
    mauve: {
      background: "#673AB7",
      darkerPrimary: "#490DB4",
      primaryText: "#000000",
      statusBarText: "light-content",
      white: "#ffffff",
      buttonText: "#ffffff",
      inActiveLabelColor: "#8e8e8f",
      ayobaThemeBackground: "#ffffff",
      ayobaButtonBackground: "#673AB7",
      ayobaButtonColor: "white",
      black: "#000000",
      accentBackground: "#ffffff",
      mashupBackground: "#FFFFFF",
    },
    midnight: {
      background: "#000000",
      darkerPrimary: "#FFFFFF",
      primaryText: "#ffffff",
      statusBarText: "light-content",
      white: "#ffffff",
      buttonText: "#ffffff",
      inActiveLabelColor: "#8e8e8f",
      ayobaThemeBackground: "#000000",
      ayobaButtonBackground: "#ffffff",
      ayobaButtonColor: "black",
      black: "#000000",
      accentBackground: "#7F7F7F",
      mashupBackground: "#1D1D1D",
      mtnBlue: "#00678F",
    },
  },

  fonts: {
    light: "MTNBrighterSans-Light",
    lightItalic: "MTNBrighterSans-LightItalic",
    extraLight: "MTNBrighterSans-ExtraLight",
    extraLightItalic: "MTNBrighterSans-ExtraLightItalic",
    regular: "MTNBrighterSans-Regular",
    regularItalic: "MTNBrighterSans-RegularItalic",
    medium: "MTNBrighterSans-Medium",
    mediumItalic: "MTNBrighterSans-MediumItalic",
    bold: "MTNBrighterSans-Bold",
    boldItalic: "MTNBrighterSans-BoldItalic",
    boldExtra: "MTNBrighterSans-ExtraBold",
    boldExtraItalic: "MTNBrighterSans-ExtraBoldItalic",
    system: "System",
  },
};
